import { superAdminService } from '../../../services/superAdmin.service.js';
import { store } from '../../store.js';
import { dispatchMultipleActions } from "../../dispatchHelper";
import { setCurrentUser } from '../../user/reducers/auth.reducer.js';


export async function getStatsSuperAdmin() {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.getStats(tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao buscar allData:', error);
        throw error;
    }
}

export async function getStatsForCompanys() {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.getCompanysStats(tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao buscar accounts:', error);
        throw error;
    }
}

export async function createSuperAdmin(name, email, password, confirmPassword) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.createSuper({ name, email, password, confirmPassword }, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao criar super admin:', error);
        throw error;
    }
}

export async function getSuperAdmins() {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.getListAdmins(tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao buscar superAdmin:', error);
        throw error;
    }
}


export async function validSuperAdmin(email) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.validate(email, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao validar superAdmin:', error);
        throw error;
    }
}

export async function deleteSuperAdmin(id) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.remove(id, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao deleter superAdmin:', error);
        throw error;
    }
}


export async function changeActiveSuperAdmin(id) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.toggleSuperAdminStatus(id, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao deleter superAdmin:', error);
        throw error;
    }
}


export async function updateUserInfo(data) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const userId = store.getState().auth?.currentUser?._id;
        const payload = {
            ...data,
            userId,
        };
        const updatedUser = await superAdminService.updateSuperAdmin(payload, tokenAdmin);

        const userPayload = {
            ...updatedUser,
            isSuperUser: true
        };
        dispatchMultipleActions(
            setCurrentUser(userPayload)
        );

        return updatedUser;
    } catch (error) {
        console.error('Erro ao atualizar perfil:', error);
        throw error;
    }
};


export async function submitGlobalNotice(notice) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const created = await superAdminService.createGlobalNotice(notice, tokenAdmin);
        return created;
    } catch (error) {
        console.error('Erro ao criar aviso:', error);
        throw error;
    }
};

export async function deleteGlobalNotice(id) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.deleteNotice(id, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao criar aviso:', error);
        throw error;
    }
};

export async function editGlobalNotice(id, updatedData) {
    try {
        const token = store.getState().auth?.token;
        return await superAdminService.editNotice(id, updatedData, token);
    } catch (err) {
        console.error('Erro ao editar aviso:', err);
        throw err;
    }
}

export async function getAllNotices() {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.getListNotices(tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao buscar superAdmin:', error);
        throw error;
    }
}

export async function createNewPlan(plan) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.createPlan(plan, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao criar plano:', error);
        throw error;
    }
}

export async function editPlan(plan) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.editPlan(plan, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao editar plano:', error);
        throw error;
    }
}

export async function deletePlan(planId) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.deletePlan(planId, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao deletar plano:', error);
        throw error;
    }
}

export async function scheduleRemoval(planId) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.scheduleRemoval(planId, tokenAdmin);
        return data;
    } catch (error) {
        console.error('Erro ao deletar plano:', error);
        throw error;
    }
}

export async function sendTestEmail(params) {
    try {
        const tokenAdmin = store.getState().auth?.token;
        const data = await superAdminService.testEmailSend(tokenAdmin, params);
        return data;
    } catch (error) {
        console.error('Erro ao realizar teste de envio de email:', error);
        throw error;
    }
}

